<template>
    <div id="app">
            <v-app-bar style="box-shadow: none;z-index: 1;height: 65px;background-color: white" :class="{'bg-linear-gradient': $vuetify.breakpoint.smAndDown}">
                <v-layout>
                    <v-flex offset-1 offset-xl2 pa-0>
                        <v-btn  @click="$router.push('/')" style="background-color: white;box-shadow: none;font-weight: bold;font-size: 18px;height: 60px;padding: 0px"><v-img style="z-index: 8"  :style="$vuetify.breakpoint.smAndDown ? {'width':'50px'}:''" :src="require('../assets/Frame.png')"></v-img></v-btn>
                        <v-btn  @click="$vuetify.goTo('#deposit')" v-show="$vuetify.breakpoint.mdAndUp" outlined class="pa-2" style="background-color: white;box-shadow: none;font-size: 13px;border-radius: unset;border: 4px solid;color: white"><span style="color: #201b2c">Deposit</span></v-btn>
                        <v-btn  @click="$vuetify.goTo('#withdraw')" outlined class="pa-2" style="background-color: white;box-shadow: none;font-size: 13px;border-radius: unset;border: 4px solid;color: white"><span style="color: #201b2c">Withdraw</span></v-btn>
                        <v-btn  @click="$vuetify.goTo('#transfer')" outlined class="pa-2" style="background-color: white;box-shadow: none;font-size: 13px;border-radius: unset;border: 4px solid;color: white"><span style="color: #201b2c">Transfer</span></v-btn>
                        <v-btn  @click="$vuetify.goTo('#QRcode')" outlined class="pa-2" style="background-color: white;box-shadow: none;font-size: 13px;border-radius: unset;border: 4px solid;color: white"><span style="color: #201b2c">Qr Code</span></v-btn>
                        <v-btn  @click="$vuetify.goTo('#API')" v-show="$vuetify.breakpoint.mdAndUp" outlined class="pa-2" style="background-color: white;box-shadow: none;font-size: 13px;border-radius: unset;border: 4px solid;color: white"><span style="color: #201b2c">API</span></v-btn>
                    </v-flex>
                </v-layout>
                <v-app-bar-nav-icon v-show="$vuetify.breakpoint.smAndDown" z-index="3" justify-end @click="drawer = !drawer" style="color: #017CFF"></v-app-bar-nav-icon>
            </v-app-bar>
            <v-navigation-drawer
                v-model="drawer"
                width="100%"
                height="100%"
                style="background-color: white"
                app
                right
                z-index="999"
                class="pa-0 d-md-none"
            >
                <v-layout row pa-0 ma-0 style="height: 100vh">
                    <v-app-bar style="background-color: white;box-shadow: none" class="pt-5 pa-0">
                        <v-layout>
                            <v-flex offset-md2>
                                <v-btn  @click="$router.push('/')" style="background-color: white;box-shadow: none;font-weight: bold;font-size: 18px;height: 60px;padding: 0px"><v-img  :style="$vuetify.breakpoint.smAndDown ? {'width':'50px'}:''" :src="require('../assets/Frame.png')"></v-img></v-btn>
                            </v-flex>
                        </v-layout>
                        <v-icon justify-end @click="drawer = !drawer" style="color: #017CFF">clear</v-icon>
                    </v-app-bar>

                        <v-flex align-center class="col-12">
                            <!--                        <v-btn @click="$router.push('/players')" class="pt-7 pb-7" style="width: 100%;box-shadow: none;font-size: 1.5rem;justify-content: unset">Players</v-btn>-->
                            <!--                        <v-btn class="pt-7 pb-7"  style="width: 100%;box-shadow: none;font-size: 1.5rem;justify-content: unset">Shoppers</v-btn>-->
                            <!--                        <v-btn class="pt-7 pb-7"  style="width: 100%;box-shadow: none;font-size: 1.5rem;justify-content: unset">Makers</v-btn>-->
                            <!--                        <v-btn @click="$router.push('/token')" class="pt-7 pb-7"  style="width: 100%;box-shadow: none;font-size: 1.5rem;justify-content: unset">Token</v-btn>-->
                            <!--&lt;!&ndash;                        <v-btn class="pt-7 pb-7"  style="width: 100%;box-shadow: none;font-size: 1.5rem;justify-content: unset">Token Swap</v-btn>&ndash;&gt;-->
                            <v-list-item-group mandatory color="#1353DB">
                                <v-list-item  :to="linkhome" link >
                                    <v-list-item-content>
                                        <v-list-item-title>HOME</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item  :to="linkdeposit" link >
                                    <v-list-item-content>
                                        <v-list-item-title>DEPOSIT</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item  :to="linkwithdraw" link >
                                    <v-list-item-content>
                                        <v-list-item-title>WITDRAW</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item :to="linktranfer" link>
                                    <v-list-item-content>
                                        <v-list-item-title>TRANSFER</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item :to="linkqr" link>
                                    <v-list-item-content>
                                        <v-list-item-title>Qr Code</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item :to="linkapi" link>
                                    <v-list-item-content>
                                        <v-list-item-title>API</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list-item-group>
                        </v-flex>

                </v-layout>

            </v-navigation-drawer>
    </div>
</template>

<script>
    export default {
        name: "Appbar",
        components: {

        },
        data: () => ({
            drawer: false,
            linkhome: '/',
            linkdeposit: '/players',
            linkwithdraw: '/',
            linktranfer: '/',
            linkqr: '/',
            linkapi: '/token'
        })
    }
</script>

<style scoped>
    .headname {
        z-index: 9999;
    }
    .bg-linear-gradient {
        background: linear-gradient(180deg, #FFFFFF 57.69%, rgba(255, 255, 255, 0) 100%);
    }
</style>
